// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"604":"6a51a7dc","700":"a1bf9242","704":"023d1b07","737":"4050236b"}[chunkId] + ".chunk.css";
};